/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_6_AInputs */

const en_pc_faq_6_a = /** @type {(inputs: Pc_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Universal), Windows 10 and 11 (x64, ARM64, x86), Linux (x86_64, ARM64, RISC-V) and FreeBSD 14, plus a WebAssembly build you can host. A GPU with Metal, Vulkan, DirectX 12 or WebGPU is recommended.`)
};

const zh_pc_faq_6_a = /** @type {(inputs: Pc_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS（通用版）、Windows 10 / 11（x64、ARM64、x86）、Linux（x86_64、ARM64、RISC-V）和 FreeBSD 14，另有可自行部署的 WebAssembly 版本。建议使用支持 Metal、Vulkan、DirectX 12 或 WebGPU 的显卡。`)
};

/**
* | output |
* | --- |
* | "macOS (Universal), Windows 10 and 11 (x64, ARM64, x86), Linux (x86_64, ARM64, RISC-V) and FreeBSD 14, plus a WebAssembly build you can host. A GPU with Metal..." |
*
* @param {Pc_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_6_a = /** @type {((inputs?: Pc_Faq_6_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_6_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_6_a(inputs)
	return zh_pc_faq_6_a(inputs)
});
export { pc_faq_6_a as "pc.faq.6.a" }